// extracted by mini-css-extract-plugin
export default {"modalOverlay":"Ny-z","modalContent":"Oy-z","header":"Py-z","close":"Qy-z"};